import useHttpQuery from 'data/firestore/useHttpQuery';
import { ACTIONS_BASE_URL } from '../../../constants';
import { NexhealthLocationEnvelope } from '../types';

const useNexhealthLocation = (
    agentId: string,
    locationId?: number,
    enabled = false,
) => useHttpQuery<NexhealthLocationEnvelope>({
    pathname: `/organizations/${agentId}/apps/nexhealth/locations/${locationId}`,
    server: ACTIONS_BASE_URL,
    key: ['nexhealth', 'location', agentId, locationId],
    queryOptions: {
        enabled: Boolean(agentId && locationId) && enabled,
        retry: false,
    },
});

export default useNexhealthLocation;
